import { compose, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { fetchBrandsAdmin } from '../../search/actions';
import BrandField from '../components/BrandField';
import withLoading from '../../../common/withLoading';

const BrandFieldContainer = compose(
  withLoading,
  connect(
    (state) => ({
      showLoading: state.admin.isFetching,
      searchResults: state.search.results || [],
    }),
    { fetchBrandsAdmin }
  ),
  withState('value', 'setValue', (props) => props.input.value),
  withState('suggestedBrands', 'setSuggestedBrands', []),
  withHandlers({
    getSuggestions: (props) => (value) => {
      const inputValue = value.trim().toLowerCase();

      if (!inputValue) return [];

      return props.searchResults
        .filter((result) => result.document?.name?.toLowerCase().includes(inputValue))
        .map((result) => ({
          id: result.document.id,
          name: result.document.name,
        }));
    },
    getIdFromValue: (props) => (value) => {
      if (!value) return '';

      const brandObject = props.searchResults.filter(
        (result) =>
          result.document && result.document.name && result.document.name.toLowerCase() === value.toLowerCase()
      );

      if (brandObject.length > 0) return brandObject[0].document.id;
      return '';
    },
  }),
  withHandlers({
    getSuggestionValue: () => (suggestion) => suggestion.name,
    renderSuggestion: () => (suggestion) => suggestion.name,
    onChange:
      (props) =>
      (event, { newValue }) => {
        props.setValue(newValue);
        const brandId = props.getIdFromValue(newValue);
        props.change(props.input.name, newValue);
        props.change(props.brandIdField, brandId);
      },
    onBlur: () => () => null,
    onSuggestionsFetchRequested:
      (props) =>
      ({ value }) => {
        if (!value) {
          props.setSuggestedBrands([]);
          return;
        }

        props.fetchBrandsAdmin(value).then(() => {
          const suggestions = props.getSuggestions(value);
          props.setSuggestedBrands(suggestions);
        });
      },
    onSuggestionsClearRequested: (props) => () => props.setSuggestedBrands([]),
  })
)(BrandField);

export default BrandFieldContainer;
